export default __webpack_public_path__ + "static/media/Pharmacon of Negation.9c4e069c.jpg";